import * as types from '../types.js';

export default {

	html: `
		<style>
			#create-invoices .purpose	{ width: 100%;	}
			#create-invoices #info		{ width: 30rem;	}
			#create-invoices #include
			{
				display: inline-block;
			}
		</style>
		<form id="create-invoices" class="form" autocomplete="off">
			<div class="title">
				Gerar notas para <span id="count"></span> saídas
			</div>
			<div class="mtl">
				<label class="purpose" title="Finalidade da emissão">Finalidade
					<select id="purpose" required>
						<option value="1" selected>Venda de mercadoria</option>
						<option value="2">Devolução de compra ou venda</option>
						<option value="3">Baixa de estoque</option>
						<option value="4">Remessa em bonificação</option>
						<option value="5">Remessa de amostra grátis</option>
						<option value="6">Remessa por conta e ordem de terceiros</option>
					</select>
				</label>
			</div>
			<div>
				<label title="Informações complementares de interesse do contribuinte">Informações Complementares
					<textarea id="info" rows="6"></textarea>
				</label>
			</div>
			<div class="tal">
				<label title="Incluir observações dos pedidos nas informações complementares das notas">
					<input id="include" type="checkbox" checked>
					Incluir observações dos pedidos
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Gerar</button>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#create-invoices',
		init(formset)
		{
			formset.form.eraseValues();
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#purpose' }, types: [types.select()] },
		{ properties: { selector: '#info' }, types: [types.textarea()] },
		{ properties: { selector: '#include' }, types: [types.checkbox()] },
	]

};

